import * as React from "react";
import { Route, RouteProps, RouteComponentProps } from "react-router";

export interface Props extends RouteProps {
  layout?: React.ComponentType;
}

const LayoutRoute = (props: Props) => {
  const LayoutComp = props.layout;
  let children:
    | ((props: RouteComponentProps<{}>) => React.ReactNode)
    | null = null;
  if (!children && props.render) {
    const render = props.render;
    children = (childProps: RouteComponentProps<{}>) => render(childProps);
  }
  if (!children && props.component) {
    const Render = props.component;
    children = (childProps: RouteComponentProps<{}>) => (
      <Render {...childProps} />
    );
  }
  if (children && LayoutComp) {
    return (
      <Route
        {...props}
        component={undefined}
        render={(childProps: RouteComponentProps<{}>) => (
          <LayoutComp>{children && children(childProps)}</LayoutComp>
        )}
      />
    );
  }
  return <Route {...props} />;
};

export default LayoutRoute;



// WEBPACK FOOTER //
// ./src/components/LayoutRoute/LayoutRoute.tsx